import { ed25519 } from '@noble/curves/ed25519';
import { bytesEqual } from './util.js';
/**
 * TODO: docs
 */
export function verifyMessageSignature({ message, signedMessage, signature, publicKey, }) {
    // TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
    return bytesEqual(message, signedMessage) && ed25519.verify(signature, signedMessage, publicKey);
}
/**
 * TODO: docs
 */
export function verifySignMessage(input, output) {
    const { message, account: { publicKey }, } = input;
    const { signedMessage, signature } = output;
    return verifyMessageSignature({ message, signedMessage, signature, publicKey: publicKey });
}
//# sourceMappingURL=signMessage.js.map